import React from 'react';
import PropTypes from 'prop-types';
import { MDText } from 'i18n-react';
import ModalConfirmation from '@adsk/bim360-matrix-react-modal-confirmation';
import { useLocale } from '@adsk/bim360-matrix-react-helpers/es/locale';
import { entityShape, pluginShape } from './helpers/propTypes';
import objectValues from '@adsk/bim360-matrix-react-helpers/es/objectValues';
import { ENTITY_TYPES } from './helpers/consts';

const RemoveConfirmationModal = ({
  typeToPlugin,
  container,
  relationToConfirmRemoving,
  closeConfirmRemoveModal,
  onRemove,
  isRemoving,
  sourceEntityType
}) => {
  const { T } = useLocale(({ locale }) => new MDText(require(`./i18n/${locale}.json`)));

  const entityType = relationToConfirmRemoving ? relationToConfirmRemoving.entity.entityType : null;
  const typeText = entityType ? T.translate(`${sourceEntityType}_SHORT_NAME`) : '';
  const plugin = typeToPlugin[entityType];
  const name = relationToConfirmRemoving
    ? plugin.formatEntityDisplayText(relationToConfirmRemoving.entity)
    : '';

  return (
    <ModalConfirmation
      show={!!relationToConfirmRemoving}
      title={T.translate('REMOVE_LINK_TITLE')}
      message={T.translate('REMOVE_LINK_MESSAGE', {
        type: typeText,
        name
      })}
      onConfirm={onRemove}
      onExited={closeConfirmRemoveModal}
      confirmationButtonLabel={T.translate('REMOVE')}
      confirmationButtonLabelInProgress={T.translate('REMOVING')}
      isOnConfirmInProgress={isRemoving}
      container={container}
    />
  );
};

RemoveConfirmationModal.propTypes = {
  /**
   * A map of entity type to plugin.
   */
  typeToPlugin: PropTypes.objectOf(pluginShape),
  /**
   * The remove confirmation data.
   */
  relationToConfirmRemoving: PropTypes.shape({
    entity: entityShape.isRequired
  }),
  /**
   * Handler for closing the modal.
   */
  closeConfirmRemoveModal: PropTypes.func,
  /**
   * Handler to remove entity relationship.
   */
  onRemove: PropTypes.func.isRequired,
  /**
   * Whether we're currently in removing process.
   */
  isRemoving: PropTypes.bool,
  /**
   * A container to attach the modal to
   */
  container: PropTypes.object,
  /**
   * the entity type that is being unlinked
   */
  sourceEntityType: PropTypes.oneOf(objectValues(ENTITY_TYPES)).isRequired
};

export default RemoveConfirmationModal;
